// This file must be present so auto.require.config.js will find and pre-require this module
define('service/app.menu.service',['require','exports','module','fukit','backbone.radio','fukit'],function(require, exports, module) {
  var FuKit = require('fukit'),
    Radio = require('backbone.radio'),
    config = require('fukit').config;

  FuKit.AppMenuService.onAppReady = function() {
    var layout = this.options.layout;
    var userPrincipal = Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel');
    var token = localStorage.getItem('fk_accessToken');

    //If it's "form answer mode" then this makes it appear as Profile App.
    var appName = config.get('cayuse.apps.switcher.active.name');
    var showLogo = config.get('cayuse.menu.show') === undefined || config.get('cayuse.menu.show');

    this.appHeaderContainerView.options.appHeaderView.template = function() {
      return '        <cayuse-header id="cayuse-header"\n' +
        '            product="' + appName + '"\n' +
        '            host=""\n' +
        '            user-id="' + userPrincipal.id + '"\n' +
        '            authentication-token="' + token + '"\n' +
        '            customer-image="NONE"\n' +
        '            use-progress-bar="false"\n' +
        '        />';

    };

    function handleNavigationChange(event) {
      var path = '';
      if (typeof event.detail == 'string') {
        path = event.detail;
      } else {
        path = event.detail.path;
      }
      
      if (path === '/logout') {
        Radio.channel('evicommon.authenticationService').request('logout');
      } else {
        if (path === '/profile' && config.get('PROFILE_URL')) {
            path = config.get('PROFILE_URL');
          }
        window.location.href = path;
      }
    }

    this.appHeaderContainerView.options.appHeaderView.onRender = function() {
      this.$el.on('navigationChange', function(event) {
        handleNavigationChange(event)
      });

      this.$el.on('productSelected', function(event) {
        handleNavigationChange(event)
      });
    };

    layout.showChildView('header', this.appHeaderContainerView);

  }

  module.exports = FuKit.AppMenuService

});

